import React, { useState, useContext } from "react";
import cloneDeep from "lodash/cloneDeep";
import cloudfront from "helpers/cloudfront";
import { Icon } from "components/SvgIcons";
import GroceryContext from "./GroceryContext";
import GroceryIngredient from "./GroceryIngredient";
import CompletedIngredientItems from "./CompletedIngredientItems";
import separateCompletedItems from "./separateCompletedItems";
import getCollectionColor from "./getCollectionColor";
import { useRouter } from "next/router";
import {
  ItemHead,
  ItemContent,
  LeftCol,
  RightCol,
  RecipeImage,
  NoImage,
  Description,
  RecipeTitle,
  CollectionsNames,
  CollectionName,
  IconWrapper,
  YieldText,
  YieldCounter,
  YieldCounterWrap,
} from "./styled";
import { getImageName } from "../../helpers";

const GroceryItem = ({ grocery }) => {
  const [isOpen, setOpen] = useState(false);
  const { removeGroceryItem, updateYields } = useContext(GroceryContext);
  const router = useRouter();

  const {
    yields: { value: yieldCounter },
  } = grocery;

  const toggleItem = () => {
    setOpen(!isOpen);
  };

  const openRecipe = () => {
    router.push(`/recipe/${grocery.recipe.id}`);
  };

  const groceryClone = cloneDeep(grocery);
  const { uncompletedIngredients, completedItems } = separateCompletedItems(groceryClone);
  const { title, main_image } = grocery.recipe;
  const collectionsNames = grocery.collection_titles instanceof Array ? grocery.collection_titles : [];

  return (
    <>
      <ItemHead>
        <LeftCol>
          <IconWrapper onClick={toggleItem} isOpen={isOpen}>
            <Icon icon="swipe_next" />
          </IconWrapper>
          <RecipeImage>
            {main_image ? (
              <img src={cloudfront({ href: main_image, size: "small" })} alt={getImageName(main_image)} />
            ) : (
              <NoImage>
                <Icon icon="creator" />
              </NoImage>
            )}
          </RecipeImage>
          <Description>
            <RecipeTitle>{title}</RecipeTitle>
            <CollectionsNames>
              {collectionsNames.map((name) => (
                <CollectionName key={name} color={getCollectionColor(name)}>
                  {name}{" "}
                </CollectionName>
              ))}
            </CollectionsNames>
          </Description>
        </LeftCol>
        <RightCol>
          <YieldCounterWrap>
            <Icon icon="yield" />
            <YieldText>Yield:</YieldText>
            <YieldCounter>
              <Icon icon="minus" onClick={() => updateYields(grocery.id, "minus")} />
              {yieldCounter}
              <Icon icon="plus" onClick={() => updateYields(grocery.id, "plus")} />
            </YieldCounter>
          </YieldCounterWrap>
          <Icon icon="new_tab" onClick={openRecipe} />
          <Icon icon="delete" onClick={() => removeGroceryItem(grocery.id)} />
        </RightCol>
      </ItemHead>
      {isOpen && (
        <ItemContent>
          {uncompletedIngredients.map((ingredient) => (
            <GroceryIngredient key={ingredient.id} ingredient={ingredient} />
          ))}
          <CompletedIngredientItems items={completedItems} />
        </ItemContent>
      )}
    </>
  );
};

export default GroceryItem;
